<template>
  <div class="collectItem">
    <div class="imgbox" @click.stop.prevent="gotoLook">
      <img
        class="imgs"
        :src="item.thumb | imageUrl('/static/collect/default.png', 446, 252)"
        alt=""
      />
      <img
        class="imgIcon"
        src="/static/collect/icon_playlist_corner@2x.png"
        alt=""
      />
      <div class="popBox" @click.stop.prevent="gotoVideo(item)" v-if="item.videoCount">
        <div class="buttomBox">
          <img
            class="hoverIcon"
            src="/static/collect/icon_playlist_hover_playall@2x.png"
            alt=""
          />{{$t('collect.播放全部')}}
        </div>
      </div>
    </div>
    <p class="title" @click.stop.prevent="gotoLook">{{ item.name }}</p>
    <div class="number">
      <p
        class="title1"
        v-if="step == 2"
        @click.stop.prevent="gotoPeople(item.userId)"
      >
        <img :src="item.userAvatar | imageUrl('', 40, 40)" alt="" />{{
          item.nickName
        }}<i>·</i>
      </p>
      <p class="title2">{{ item.videoCount || 0 }}{{$t('collect.个视频')}}</p>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "collectItem",
  props: ["item", "step"],
  data() {
    return {};
  },
  created() {},
  methods: {
    gotoLook() {
      let routeData = this.$router.resolve({
        path: "/playlist/" + this.item.id,
      });
      window.open(routeData.href, "_blank");
    },
    gotoPeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home",
      });
      window.open(routeData.href, "_blank");
    },
    gotoVideo(item) {
      if (item.videoCount && item.videoCount > 0) {
        let params = {
          id: item.id,
          pageIndex: 1,
          pageSize: 1,
        };
        this.$http
          .get("/api/fav/collectVideoList/" + item.id, { params })
          .then((res) => {
            let list = res.data.list;
            let routeData = this.$router.resolve({
              path:
                "/video/detail?id=" + list[0].id + "&lookId=" + item.id,
            });
            window.open(routeData.href, "_blank");
          });
      } else {
        this.$message({
          message: this.$t('collect.该看单还没有收藏视频！'),
          offset: 220,
        });
      }
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>
<style lang="stylus" scoped>
.collectItem {
  width: 223px;
  cursor: pointer;

  .imgbox {
    width: 223px;
    height: 126px;
    position: relative;

    .imgs {
      width: 223px;
      height: 126px;
    }

    .imgIcon {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 28px;
      height: 28px;
    }

    .popBox {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      position: absolute;
      left: 0;
      top: 0;
      text-align: center;
      display: none;

      .buttomBox {
        width: 90px;
        height: 32px;
        line-height: 32px;
        border: 1px solid #FFFFFF;
        font-size: 13px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        cursor: pointer;

        .hoverIcon {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .title {
    max-height: 40px;
    font-size: 14px;
    font-weight: 600;
    color: #0A0A0A;
    line-height: 20px;
    margin: 8px 0 6px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-word;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  .number {
    height: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;

    .title1 {
      vertical-align: middle;
      display: inline-block;
      max-width: 130px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 6px;
      }
    }

    i {
      margin: 0 4px;
    }

    .title2 {
      vertical-align: middle;
      display: inline-block;
    }
  }

  &:hover {
    .popBox {
      display: block;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/collect/collectItem.vue